import { render } from "./ItemVe.vue?vue&type=template&id=ce7bb2d4&scoped=true"
import script from "./ItemVe.vue?vue&type=script&lang=js"
export * from "./ItemVe.vue?vue&type=script&lang=js"

import "./ItemVe.vue?vue&type=style&index=0&id=ce7bb2d4&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce7bb2d4"]])

export default __exports__